export const BOOKING_ATTENDANCE = {
    PENDING: 'pending',
    ATTENDED: 'attended',
    NO_SHOW: 'no_show',
    UNOBSERVED: 'unobserved',
};
export const BOOKING_ATTENDANCE_VALUES = Object.values(BOOKING_ATTENDANCE);
export const ATTENDANCE_SIGNAL_KIND = {
    CHECK_IN: 'check_in',
    PRESENTED: 'presented',
    DEGRADED: 'degraded',
    OVERRIDE: 'override',
    TAMPER: 'tamper',
};
export const ATTENDANCE_SIGNAL_KIND_VALUES = Object.values(ATTENDANCE_SIGNAL_KIND);
export const CHECK_IN_OPENS_MINUTES_BEFORE = 5;
export function isBookingAttendance(value) {
    return typeof value === 'string' && BOOKING_ATTENDANCE_VALUES.includes(value);
}
export function isAttendanceSignalKind(value) {
    return typeof value === 'string' && ATTENDANCE_SIGNAL_KIND_VALUES.includes(value);
}
//# sourceMappingURL=attendance.js.map